import React, { useState, useEffect, useRef, useCallback } from "react";
import "./index.less";
import { Pagination } from "antd";
import { useNavigate } from "react-router-dom";
import { request } from "@/utils/request"
import NavigationBar from "@/components/NavigationBar";
import search from '@/assets/search.png'
import eat from '@/assets/eat.png'
import address from '@/assets/address.png'
import noSearch from '@/assets/noSearch.png'
import sort1 from '@/assets/sort1.png'
import sort2 from '@/assets/sort2.png'
import sort3 from '@/assets/sort3.png'
import day from '@/assets/day.png'
import night from '@/assets/night.png'
import Config from "@/config/config";
import honor from '@/assets/honor.png'
import {
    DownOutlined,
    UpOutlined
} from '@ant-design/icons';
import { fail } from "assert";

export default function Collect() {
    const navigate = useNavigate();
    const [recommend, setRecommend] = useState([])
    const [page, setPage] = useState(1)

    const [perPage, setPerPage] = useState(12);
    const [total, setTotal] = useState(0)
    const listRef = useRef(null);

    const fetchData = async (page, perPage,) => {
        try {
            let url = '/restaurant/collect-list' + "?page=" + page + "&per_page=" + perPage
            const response = await request.get(url);
            let data = response.data
            setRecommend(data)
            setTotal(response._meta.totalCount)
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };

    useEffect(() => {
        // listRef.current.scrollIntoView({ behavior: "smooth" })
        if (listRef.current) {
            window.scrollTo(0, 0)
        }
    }, [recommend])


    const pageChange = (e, v) => {

        setPage(e)
        setPerPage(v)
        fetchData(e, v)
    };

    const doSearch = (val) => {
        // fetchData(0, perPage, val)
        console.log(val)
        // fetchData(0,perPage,val)
        navigate('/search?name=' + val)
    }


    useEffect(() => {
        sessionStorage.setItem("mbx", "collect")
        fetchData(page, perPage);

    }, []);

    return (
        <div className="collect" ref={listRef}>
            <NavigationBar showNavRight={true} showNavTabs={true} showSearch={true}
                onSearchChange={doSearch}></NavigationBar>
            <div className="collect-heart">
                <div className="type-collectList" >
                    <div className="collectList-content">
                        {
                            recommend.length > 0 ? <>
                                {
                                    recommend.map((item, idx) => {
                                        return (
                                            // 如果你想在 style 属性中添加更多判断，可以使用三元运算符或者对象合并的方式。以下是一个修改后的代码示例，它根据 idx 是否为 4 的倍数来设置 marginRight 属性：
                                            <div key={item.id} className='collectList-items' onClick={() => navigate('/detail?id=' + item.id)}>
                                                <img
                                                    objectFit="cover"
                                                    src={Config.imgPrefix + item.cover[0]}
                                                    className="cover" alt="" />
                                                <div className="info">
                                                    <div className="name">
                                                        <div className="name-txt">{item.name}</div>
                                                    </div>
                                                    <div className="honors">
                                                        {
                                                            item.honors?.map(v => {
                                                                return <img className='honorLog' src={Config.imgPrefix + v.cover} />
                                                            })
                                                        }
                                                    </div>
                                                    {
                                                        !!item.name_en && <div className="name_en">{item.name_en}</div>
                                                    }

                                                    <div className="city" style={{ fontSize: "12px" }}>{item.category && item.category + '/'}{item.region && item.region}</div>
                                                    <div className="price">
                                                        {
                                                            !!item.lunch_price && <div className="lunch_price price-item"><img src={day} alt="" className="icon" /> <div>JPY {item.lunch_price}</div></div>
                                                        }
                                                        {
                                                            !!item.supper_price && <div className="supper_price price-item"><img src={night} alt="" className="icon" /> <div>JPY {item.supper_price}</div></div>
                                                        }
                                                    </div>
                                                    <div className="notification" dangerouslySetInnerHTML={{__html:item.notification}}>
                                                        {/* {item.notification} */}
                                                    </div>
                                                </div>

                                            </div>
                                        )
                                    })
                                }
                            </> :
                                <div className='no-data'>
                                    <img src={noSearch} alt="" srcset="" className='searchIcon' />
                                    <div className='no-data-tip'>您还没有收藏店铺</div>
                                </div>
                        }
                    </div>
                    {
                        total == 0 ? null : <div className='pagination-box'>
                            <Pagination
                                className='main-pagination'
                                total={total}
                                pageSize={perPage}
                                pageSizeOptions={[12, 24, 36, 48]}
                                onChange={pageChange}
                                showQuickJumper
                                showTotal={(total) => `共${total}条`}
                                current={page}
                            />
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}
